import React from "react";
import PropTypes from "prop-types";
import { Card, Grid, Box, Typography } from "@mui/material";
import { Security as SecurityIcon } from "@mui/icons-material";

import MDBox from "shared/components/MDBox";
import MDTypography from "shared/components/MDTypography";

const HeaderPermisos = ({ children, title, subtitle }) => {
  return (
    <MDBox position="relative" sx={{ mt: -2, mx: -3, py: 2, px: -2 }}>
      <Card
        sx={{
          mt: 1,
          mx: 3,
          py: 3,
          px: 3,
          borderRadius: 3,
          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
          overflow: "hidden",
        }}
      >
        {/* Header con gradiente */}
        <Box
          sx={{
            background: "linear-gradient(135deg, #1e293b 0%, #0b4f6c 100%)",
            margin: -3,
            marginBottom: 3,
            padding: 3,
            borderBottom: "1px solid rgba(255,255,255,0.1)",
          }}
        >
          <Grid container alignItems="center" justifyContent="space-between" spacing={2}>
            <Grid item xs={12}>
              <Box display="flex" alignItems="center" gap={2}>
                <SecurityIcon sx={{ fontSize: 40, color: "rgba(255,255,255,0.8)" }} />
                <Box>
                  <MDTypography
                    variant="h4"
                    fontWeight="bold"
                    sx={{ color: "rgba(255, 255, 255)" }}
                  >
                    {title || "Gestión de Permisos"}
                  </MDTypography>
                  <MDTypography variant="body2" sx={{ color: "rgba(255,255,255,0.7)", mt: 0.5 }}>
                    {subtitle || "Administre los permisos de los usuarios de copropiedad"}
                  </MDTypography>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>

        {/* Contenido */}
        <Box sx={{ mt: 2 }}>
          {React.Children.map(children, (child) => {
            if (React.isValidElement(child)) {
              return React.cloneElement(child, {
                style: {
                  ...child.props.style,
                  animation: "fadeIn 0.3s ease-in-out",
                },
              });
            }
            return child;
          })}
        </Box>
      </Card>
    </MDBox>
  );
};

HeaderPermisos.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

HeaderPermisos.defaultProps = {
  children: null,
  title: "Gestión de Permisos",
  subtitle: "Administre los permisos de los usuarios de copropiedad",
};

export default HeaderPermisos;
